/**
 *  @class
 *  @function CountdownTimer
 *  Günlük Saat Bazlı Geri Sayım
 *  - Her gün 00:00'da belirlenen saate kadar geri sayar
 *  - Hedef saat geçince 00:00:00 gösterir (gece yarısına kadar)
 */
if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      this.io = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.init();
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: `0px 0px 500px 0px` });

      this.io.observe(this);
    }
    
    init() {
      // Hedef saat ve dakikayı al
      this.targetHour = parseInt(this.dataset.targetHour) || 0;
      this.targetMinute = parseInt(this.dataset.targetMinute) || 0;
    }
    
    connectedCallback() {
      const hoursEl = this.querySelector('.hours .countdown-timer--column--number'),
        minutesEl = this.querySelector('.minutes .countdown-timer--column--number'),
        secondsEl = this.querySelector('.seconds .countdown-timer--column--number');
      
      const updateTime = () => {
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();
        const currentSecond = now.getSeconds();
        
        // Hedef zamanı bugün için hesapla (saat ve dakika olarak)
        const targetTotalSeconds = (this.targetHour * 3600) + (this.targetMinute * 60);
        const currentTotalSeconds = (currentHour * 3600) + (currentMinute * 60) + currentSecond;
        
        // Kalan süreyi hesapla
        let remainingSeconds = targetTotalSeconds - currentTotalSeconds;
        
        // Hedef saat geçtiyse 00:00:00 göster
        if (remainingSeconds <= 0) {
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          requestAnimationFrame(updateTime);
          return;
        }
        
        // Saat, dakika, saniye hesapla
        const hours = Math.floor(remainingSeconds / 3600);
        const minutes = Math.floor((remainingSeconds % 3600) / 60);
        const seconds = remainingSeconds % 60;
        
        hoursEl.textContent = CountdownTimer.addZero(hours);
        minutesEl.textContent = CountdownTimer.addZero(minutes);
        secondsEl.textContent = CountdownTimer.addZero(seconds);
        
        requestAnimationFrame(updateTime);
      };
      
      requestAnimationFrame(updateTime);
    }
    
    static addZero(x) {
      return (x < 10 && x >= 0) ? "0" + x : x;
    }
  }
  customElements.define('countdown-timer', CountdownTimer);
}
